import React from "react";
import Container from "../container/container";
import Divider from "../divider/divider";

const SectionStart = (props) => {
  const { children, className, style, id, noDivider = false } = props;
  return (
    <section>
      <Container style={style} className={undefined} id={id}>
        <Container inner className={className}>
          {children}
        </Container>
        {!noDivider && <Divider />}
      </Container>
    </section>
  );
};

export default SectionStart;
